import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-navy-800 text-slate-300 mt-20">
    <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-14 grid gap-10 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2.5 mb-4">
          <img src="/safety-jobs-logo.png" alt="Safety Jobs" className="h-10 w-10 rounded-lg" />
          <div className="font-display font-extrabold text-white text-lg">Safety Jobs</div>
        </div>
        <p className="text-sm text-slate-400 max-w-sm leading-relaxed">
          The U.S. marketplace for safety careers. Free to browse. Employers post for $99 / 60 days.
          Applicants apply to unlimited jobs for $10 / 30 days.
        </p>
      </div>
      <div>
        <h4 className="text-xs uppercase tracking-[0.15em] font-semibold text-amber-500 mb-4">Explore</h4>
        <ul className="space-y-2.5 text-sm">
          <li><Link to="/jobs" className="hover:text-white transition-colors">Browse Jobs</Link></li>
          <li><Link to="/post-job" className="hover:text-white transition-colors">Post a Job</Link></li>
          <li><Link to="/membership" className="hover:text-white transition-colors">Applicant Membership</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs uppercase tracking-[0.15em] font-semibold text-amber-500 mb-4">Legal</h4>
        <ul className="space-y-2.5 text-sm">
          <li><Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
          <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy & Consent</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-5 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} Safety Jobs. U.S. safety careers only.</span>
        <span>Built for a safer workforce.</span>
      </div>
    </div>
  </footer>
);
